import React, { useMemo } from 'react'
import { Card, CardContent, CircularProgress, Typography } from '@mui/material'
import ReactECharts from 'echarts-for-react'
import moment from 'moment'
import 'moment/locale/fr'
import { orderBy, range, uniq } from 'lodash'
import ApplicationConf from 'conf/ApplicationConf'
import useFetch from 'common/hooks/useFetch'
import { CardTitle } from 'common/components/card/Card'
import { darkBlue } from 'app/theme'
import { STATUS } from 'common/constants/storeConstants'

const MONTHS = range(1, 13)
const MONTH_LABELS = MONTHS.map(m => moment({ month: m - 1 }).locale('fr').format('MMM'))

const formatNb = (nb) => Number(nb).toLocaleString('fr-FR')

// Nombre de bans fail2ban par mois, une série (barres) par année pour comparer les années entre elles.
const Fail2banStatChart = () => {
    const { data = [], status } = useFetch(ApplicationConf.supervision.fail2banStat())

    const option = useMemo(() => {
        const rows = data.filter(d => d.serveur === 'all' && d.jail === 'all')
        const years = orderBy(uniq(rows.map(d => d.year)))
        return {
            tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, valueFormatter: formatNb },
            legend: { data: years.map(String) },
            grid: { left: 60, right: 20, top: 40, bottom: 30 },
            xAxis: { type: 'category', data: MONTH_LABELS },
            yAxis: { type: 'value', axisLabel: { formatter: formatNb } },
            series: years.map(year => ({
                name: String(year),
                type: 'bar',
                data: MONTHS.map(month => rows.find(d => d.year === year && d.month === month)?.nb ?? null),
            })),
        }
    }, [data])

    return (
        <Card sx={{ height: '100%' }}>
            <CardTitle title='Fail2ban — bans par mois' color={darkBlue} />
            <CardContent>
                {status === STATUS.LOADING && data.length === 0 && <CircularProgress size={24} />}
                {status === STATUS.REJECTED && <Typography sx={{ fontSize: 13, color: '#c62828' }}>Impossible de charger les stats fail2ban</Typography>}
                {data.length > 0 && <ReactECharts option={option} style={{ height: 350 }} notMerge />}
            </CardContent>
        </Card>
    )
}

export default Fail2banStatChart
